import { render, staticRenderFns } from "./merchantSurchargeManagementDetails.vue?vue&type=template&id=47956d76&scoped=true&"
import script from "./merchantSurchargeManagementDetails.vue?vue&type=script&lang=js&"
export * from "./merchantSurchargeManagementDetails.vue?vue&type=script&lang=js&"
import style0 from "./merchantSurchargeManagementDetails.vue?vue&type=style&index=0&id=47956d76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47956d76",
  null
  
)

export default component.exports